export const aboutUsContent =
  "Vermont RE Development LLC is the leader in construction of real estate and operator of the VTdevelopers.com of web site for real estate consumers and professionals. We design and build houses.";
